import React from "react";
import ExamPageLayout from "./ExamPageLayout";
import {useTranslation} from "react-i18next";

const Ielts = () => {
    const {t} = useTranslation()
    return <ExamPageLayout title={t("ieltsExamLabel")}
                           subtitle={t("ieltsExamLabelFull")}
                           description={t("ieltsExamDescription")}
                           structure={t("ieltsExamStructure")}/>
}

export default Ielts
